import { messstelle } from './../../utils/apiTypes';
import { messstellenLookupState } from './messstellenLookupTypes';
import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { AppDispatch, RootState } from '../../app/store';
import { getWithAuth } from '../../utils/api';
import { logError } from '../../utils/utils';
import { errorHandler } from '../../utils/errorHandling';


const initialState: messstellenLookupState = {
    messstellen: [],
    messstellenDict: {},
    messstellenLoading: false
}

const messstellenLookupSlice = createSlice({
    name: "messstellenLookup",
    initialState,
    reducers: {
        setMessstellen: (state, action: PayloadAction<Array<messstelle>>) => {
            state.messstellen = action.payload;
        },
        setMessstellenLoading: (state, action: PayloadAction<boolean>) => {
            state.messstellenLoading = action.payload;
        },
        setDictionary: (state, action: PayloadAction<Record<string, messstelle>>) => {
            state.messstellenDict = action.payload;
        }
    }
});

export const {
    setMessstellen,
    setMessstellenLoading,
    setDictionary
} = messstellenLookupSlice.actions

export const selectMessstellenLookup = (state: RootState): Array<messstelle> => state.messstellenLookup.messstellen;
export const selectMessstellenLoadingLookup = (state: RootState): boolean => state.messstellenLookup.messstellenLoading;
export const selectMessstellenDictionary = (state: RootState): Record<string, messstelle> => state.messstellenLookup.messstellenDict;

export const getMessstellenForLookup = () => (dispatch: AppDispatch, getState: () => RootState): void => {
    if (getState().messstellenLookup.messstellen.length == 0)
        getWithAuth("MESSSTELLE", {})
            .then((response) => {
                dispatch(setMessstellen(response));
                const temp: Array<messstelle> = response;
                const dictionary: Record<string, messstelle> = Object.assign({}, ...temp.map((x) => ({ [x.name]: x })));
                dispatch(setDictionary(dictionary));
            })
            .catch((error) => {
                logError(error);
                errorHandler(error, dispatch)
            });
};

export const clearMessstellenForLookup = () => (dispatch: AppDispatch): void => {
    dispatch(setMessstellen([]));
};

export const getMessstellenLookup = (messstellenDict: Record<string, messstelle>, messstellenName: string, lookupValue: string): string => {

    if (messstellenName in messstellenDict) {
        //eslint-disable-next-line security/detect-object-injection
        const foundedMessstelle = messstellenDict[messstellenName];
        switch (lookupValue) {
            case "umspannwerk":
                return foundedMessstelle.umspannwerk;
            case "schaltfeld":
                return foundedMessstelle.schaltfeld;    
            default:
                return "";
        }
    }
    return "";

};

export default messstellenLookupSlice.reducer